import { render, staticRenderFns } from "./Crearfarmaco.vue?vue&type=template&id=007494f0"
import script from "./Crearfarmaco.vue?vue&type=script&lang=js"
export * from "./Crearfarmaco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports